import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { LoomCardIllustrationDark } from '../assets/LoomCardIllustrationDark';

import { LoomCardIllustrationLight } from '../assets/LoomCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const LoomOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <LoomCardIllustrationLight />,
		componentDark: <LoomCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...loomMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const loomMessages = defineMessages({
	heading: {
		defaultMessage: 'Share updates with Loom',
		description: 'Heading for the Loom onboarding card',
		id: 'townsquare.twc-onboarding-widget.loom-card.heading',
	},
	description: {
		defaultMessage: 'Share async video updates and reduce meetings for all.',
		description: 'Description for the Loom onboarding card',
		id: 'townsquare.twc-onboarding-widget.loom-card.description',
	},
	cta: {
		defaultMessage: 'Try Loom',
		description: 'Call to action text for the Loom onboarding card',
		id: 'townsquare.twc-onboarding-widget.loom-card.cta',
	},
});
